export const GET_TEACHER_AUTH_TOKEN_REQUEST = 'GET_TEACHER_AUTH_TOKEN_REQUEST';
export const GET_TEACHER_AUTH_TOKEN_SUCCESS = 'GET_TEACHER_AUTH_TOKEN_SUCCESS';
export const GET_TEACHER_AUTH_TOKEN_FAILURE = 'GET_TEACHER_AUTH_TOKEN_FAILURE';

export function getTeacherAuthTokenRequest(userProfileType, userProfileId) {
    return { type: GET_TEACHER_AUTH_TOKEN_REQUEST, userProfileType, userProfileId, isGettingToken: true };
}

export function getTeacherAuthTokenSuccess({ jwt, authToken }) {
    return { type: GET_TEACHER_AUTH_TOKEN_SUCCESS, jwt, authToken, isGettingToken: false };
}

export function getTeacherAuthTokenFailure() {
    return { type: GET_TEACHER_AUTH_TOKEN_FAILURE, isGettingToken: false };
}



// WEBPACK FOOTER //
// ./app/containers/teacher-view/actions.js